/*=============================
=            Sidebar          =
=============================*/

var sidebarItems = [].slice.call(document.querySelectorAll('.sidebar-links button'));

sidebarItems.forEach(function(sidebarItem) {
	sidebarItem.addEventListener('click', function() {
		var button = this,
			child = this.nextSibling,
			animation = window.getComputedStyle(child).display == 'block' ? 'slideUp' : 'slideDown';

		[].slice.call(this.parentNode.parentNode.querySelectorAll('.active:not(.closed) + ul, .open + ul')).forEach(function(open) {
			if(open != child && !open.contains(button)) {
				button = open.previousSibling;

				Velocity(open, 'slideUp', {duration: 150});

				if(button.classList.contains('active'))
					button.classList.add('closed');
				else
					button.classList.remove('open');
			}
		});

		Velocity(child, animation, {duration: 150});

		this.classList.toggle(this.classList.contains('active') ? 'closed' : 'open');

        child.setAttribute('aria-expanded', (child.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));
	});
});

/*=============================
=    Patient Resources        =
=============================*/

function checkIfExistHash(anchor){
    return anchor.indexOf('#') > -1 ? anchor.split('#')[1] : (anchor.indexOf('://') > -1 ? '' : anchor);
}

var resourceIcons = [].slice.call(document.querySelectorAll('body.resources .icon-cards-container .icon-card a'));

resourceIcons.forEach(function(resourceIcon) {
    var tabId = checkIfExistHash(resourceIcon.getAttribute('data-href'));

    if(tabId){
        console.log(document.getElementById(tabId))
        if(document.getElementById(tabId)){
            document.getElementById(tabId).classList.add('hide');
        }
    }
    resourceIcon.addEventListener('click', function(e) {
        e.preventDefault();
        var tabId = checkIfExistHash(this.getAttribute('data-href')),
            activeTabs = document.querySelectorAll('.icon-cards-container .icon-card.active');

        // Hide all divs with the relevant id
        resourceIcons.forEach(function(resourceIcon) {
            var tabId1 = checkIfExistHash(resourceIcon.getAttribute('data-href'));
            if(tabId1){
                if (document.getElementById(tabId1)){
                    document.getElementById(tabId1).classList.add('hide');
                }
            }
        });

        activeTabs.forEach(function(tab) {
            tab.className = tab.className.replace('active', '');
        });

        // then show the clicked element
        if(document.getElementById(tabId)) {
            document.getElementById(tabId).classList.remove('hide');

            this.parentNode.classList.add('active');

            scrollToElement(document.getElementById(tabId));
        }
    });

});

